import { MappingTypeEnum } from '../../../../types';
import { getGroupedOptions } from '../helpers';

export const actionOptions = {
  quickFill: {
    value: 'Quick Fill',
    target: [MappingTypeEnum.AI_AUTHORING],
  },
  link: { value: 'Link', target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING] },
  comment: { value: 'Comment', target: Object.values(MappingTypeEnum) },
  viewComments: { value: 'View Comments', target: Object.values(MappingTypeEnum) },
  viewOrignalTemplate: { value: 'View Orignal Template', target: Object.values(MappingTypeEnum) },
  imageTagging: { value: 'Image Tagging', target: Object.values(MappingTypeEnum) },
  findFigure: {
    value: 'Find Figure',
    target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING],
  },
  reset: { value: 'Reset', target: [MappingTypeEnum.AI_AUTHORING] },
  duplicateTable: {
    value: 'Duplicate Table',
    target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING],
  },
  transferTable: {
    value: 'Transfer Table from Source',
    target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING],
  },
  autoFill: {
    value: 'Auto Fill',
    target: [MappingTypeEnum.AI_AUTHORING],
  },
};

export const exportOptions = {
  cleanDocument: {
    value: 'Clean Document',
    target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING],
  },
  annotatedDocument: {
    value: 'Annotated Document',
    target: [MappingTypeEnum.AUTHORING, MappingTypeEnum.AI_AUTHORING],
  },
};

export const groupedOptions = (
  mappingType: MappingTypeEnum,
  options: {
    /** Ignored — Quick Fill is hidden from Actions; kept for call-site compatibility. */
    isQuickFillEnabled?: boolean;
    isLinkEnabled: boolean;
    isCommentEnabled: boolean;
    isImageTaggingEnabled: boolean;
    isAutoFillEnabled: boolean;
    isResetEnabled: boolean;
    isFindFigureEnabled: boolean;
    isDuplicateTableEnabled: boolean;
    isTransferTableEnabled: boolean;
  },
) => {
  // Quick Fill omitted from Actions (legacy LLM / lot numbers); not shown in menu.
  const { quickFill: _quickFillOmitted, ...actionsForMenu } = actionOptions;

  const updatedActionOptions = {
    ...actionsForMenu,
    link: {
      ...actionOptions.link,
      disabled: !options.isLinkEnabled,
    },
    comment: {
      ...actionOptions.comment,
      disabled: !options.isCommentEnabled,
    },
    imageTagging: {
      ...actionOptions.imageTagging,
      disabled: !options.isImageTaggingEnabled,
    },
    findFigure: {
      ...actionOptions.findFigure,
      disabled: !options.isFindFigureEnabled,
    },
    autoFill: {
      ...actionOptions.autoFill,
      disabled: !options.isAutoFillEnabled,
    },
    reset: {
      ...actionOptions.reset,
      disabled: !options.isResetEnabled,
    },
    duplicateTable: {
      ...actionOptions.duplicateTable,
      disabled: !options.isDuplicateTableEnabled,
    },
    transferTable: {
      ...actionOptions.transferTable,
      disabled: !options.isTransferTableEnabled,
    },
  };
  const gOptions = [
    {
      header: '',
      options: getGroupedOptions(updatedActionOptions, mappingType),
    },
    {
      header: 'Export',
      options: getGroupedOptions(exportOptions, mappingType),
    },
  ];
  return gOptions.filter((option) => option.options.length);
};
